<template>
    <div class="px-4 py-8 sm:px-10">
        <p class="mb-2">{{ translate('body:message') }}</p>
        <p>
            <strong class="text-blue-800 md:block whitespace-pre-wrap">
                {{ translate('body:signature') }}
            </strong>
        </p>
    </div>
</template>
<script>

import translate from "../../../lang";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    setup() {
        let t = translate('auth.registrationVerified');
        return {
            translate: t
        }
    }
};
</script>
